import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=2d70802d&scoped=true&"
import script from "./videoPlayer.vue?vue&type=script&lang=js&"
export * from "./videoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=2d70802d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70802d",
  null
  
)

export default component.exports